import { Box } from '@material-ui/core';
import { formatDateReadable, formatMoney } from '@nemuru-eng/js-api-client';

import { ReportDetailsCard } from '@/components/modules/Reports/ReportDetails/ReportDetailsOverview/components/ReportDetailsCard';
import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { Text } from '@/components/shared/components/Text';
import { useScreen } from '@/hooks/useScreen';

interface ReportDetailsOverviewProps {
  report: ReportsListRowProps['row'];
}

export const ReportDetailsOverview = ({ report }: ReportDetailsOverviewProps) => {
  const { isMobile } = useScreen();
  const totalDisbursedAmount = report.payouts.reduce((acc, payout) => acc + payout.disbursedAmount.amount, 0);
  const totalAdjustmentsAmount = report.payouts.reduce((acc, payout) => acc + payout.adjustmentsAmount.amount, 0);

  return (
    <Box pb={6} display={'flex'} flexWrap={'wrap'} flex gridGap={isMobile ? '24px' : '64px'}>
      <ReportDetailsCard label={<Text tId={'REPORT_DATE'} />} value={formatDateReadable(report.reportDate)} />
      <ReportDetailsCard
        label={<Text tId={'TOTAL_ADJUSTMENTS'} />}
        value={formatMoney({ value: totalAdjustmentsAmount, currency: report.currency })}
      />
      <ReportDetailsCard
        label={<Text tId={'TOTAL_DISBURSED_AMOUNT'} />}
        value={formatMoney({ value: totalDisbursedAmount, currency: report.currency })}
      />
    </Box>
  );
};
